import { Injectable } from '@angular/core';
import { TitleCasePipe } from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class EstadosConductorService {

  static readonly ESTADOS_GESTION_CONDUCTOR: { [key: string]: string } = {
    DISPONIBLE: "Disponible",
    EN_CURSO: "En Ruta",
    EN_PATIO: "Apoyo Patio",
    EN_COLACION: "En Colación",
    REVISION_TECNICA: "En Rev Técnica",
    // NO_DISPONIBLE: "No Disponible",
    FUERA_JORNADA: "Jornada Terminada",
    CAPACITACION: "Capacitación",
    EN_TALLER: "En Taller"
  };

  constructor(private titleCasePipe: TitleCasePipe) { }

  transformGestionJornadaEstado(estado: string): string {
    if (!estado)
      return '';

    if (EstadosConductorService.ESTADOS_GESTION_CONDUCTOR[estado])
      return EstadosConductorService.ESTADOS_GESTION_CONDUCTOR[estado];
    else
      return this.titleCasePipe.transform(estado.replace('_', ' '));
  }
}
